import * as React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../shared/Icon';

declare interface INavItemProps {
  color?: string;
  inverse?: boolean;
  target: string;
  title: string;
  icon: string;
  onClick?: (e: React.MouseEvent<HTMLElement>) => void;
  children?: React.ReactNode;
  firstChild?: boolean;
  lastChild?: boolean;
  name: string;
  isActive: boolean;
}

const NavItem = (props: INavItemProps): React.ReactElement => {
  const color = props.isActive
    ? 'var(--color-warning-accent)'
    : 'var(--color-text)';
  return (
    <NavItemWrapper>
      <NavLink
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        isActive={(): boolean => props.isActive}
        activeStyle={{
          background: 'var(--color-surface-6)',
          borderRadius: '10px 10px 0px 0px',
          boxShadow: 'var(--shadow-elevation-6)',
          clipPath: 'inset(0px -15px 0px -15px)',
        }}
        to={props.target}
        style={{
          display: 'flex',
          flexDirection: 'row',
          flex: 1,
          borderRadius: '10px 10px 0px 0px',
          transitionProperty: 'background',
          transitionTimingFunction: 'ease-in-out',
          transitionDuration: '.25s',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: '100%',
        }}
        title={props.title}
        onClick={props.onClick}
      >
        <Icon inverse={props.inverse} color={color} name={props.icon} />
        <NavItemTitle>{props.title}</NavItemTitle>
        {props.children}
      </NavLink>
    </NavItemWrapper>
  );
};
const NavWrapper = styled.div`
  border-bottom: 4px solid var(--color-surface-6);
  height: 100%;
  width: 100%;
`;
const NavList = styled.ol`
  list-style: none;
  display: flex;
  flex-direction: row;
  margin: 0;
  padding: 0;
  align-items: center;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
`;

const NavItemWrapper = styled.li`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  height: 100%;
  @media (max-width: 991px) {
    margin: 0px 3px;
  }
`;

export const NavItemTitle = styled.span`
  margin-left: 3px;
  font-size: 16px;
  @media (max-width: 1300px) {
    display: none;
  }
`;

interface IMatchParams {
  entityType: string;
  entityId: string;
}

interface IProps extends RouteComponentProps<IMatchParams> {
  selectedTeamId: string;
  selectedGroupId: string;
  selectedAthleteId: string;
}

export const EntityTypeMenu = withRouter(
  (props: IProps): React.ReactElement => {
    return (
      <NavWrapper>
        <NavList>
          <NavItem
            title='Teams'
            target={
              props.selectedTeamId ? `/teams/${props.selectedTeamId}` : '/teams'
            }
            icon='groups'
            name='teams'
            firstChild
            isActive={props.location.pathname.includes('teams')}
          />

          <NavItem
            title='Groups'
            target={
              props.selectedGroupId
                ? `/groups/${props.selectedGroupId}`
                : '/groups'
            }
            name='groups'
            icon='people'
            isActive={props.location.pathname.includes('groups')}
          />

          <NavItem
            title='Athletes'
            target={
              props.selectedAthleteId
                ? `/athletes/${props.selectedAthleteId}`
                : '/athletes'
            }
            icon='person'
            name='athletes'
            lastChild
            isActive={props.location.pathname.includes('athletes')}
          />
        </NavList>
      </NavWrapper>
    );
  }
);
